import { Component, OnInit, Input } from '@angular/core';
import { utilityService } from '../commonservice/utility.service';
import { geolocation } from '../commonservice/geolocation/geoloc';
import { UserGioLocation } from '../../models/user/usergioLocation';
@Component({
  selector: 'app-map',
  templateUrl: './map.component.html',
  styleUrls: ['./map.component.css'],
  providers: [utilityService]
})
export class MapComponent implements OnInit {
  @Input() positions = [];
  mapOptions: any;
  mapData: any = [];
  userGioLocation: UserGioLocation;
  constructor(private geoloc: geolocation, public utilityServ: utilityService) {
    this.userGioLocation = new UserGioLocation();
  }

  ngOnInit() {
    this.utilityServ.busy = this.geoloc.getGioLocation().subscribe(data => {
      this.userGioLocation = data;
      this.mapOptions = {
        center: { lat: this.userGioLocation.latitude, lng: this.userGioLocation.longitude },
        zoom: 10,
        mapTypeId: 'roadmap',
        tilt: 45
      };
      this.mapData = this.utilityServ.getArray(this.positions);
      this.showRandomMarkers(this.mapData);
    });
  }
  showRandomMarkers(markerCollection) {
    this.positions = [];
    for (let markerCount = 0; markerCount < markerCollection.length; markerCount++) {
      //  if(markerCollection[markerCount].Address.Latitude != undefined) {
      if (markerCollection[markerCount].Address != undefined) {
        this.positions.push([this.utilityServ.getObjectText(markerCollection[markerCount].Address.Latitude), this.utilityServ.getObjectText(markerCollection[markerCount].Address.Longitude)]);
      }
      // }
    }
  }

  onMapReady(map) {
    console.log('map', map);
    map.center.lat = this.utilityServ.getObjectText(this.mapData[0].Address.Latitude);
    map.center.lng = this.utilityServ.getObjectText(this.mapData[0].Address.Longitude);

    const position = new google.maps.LatLng(this.mapData[0].Address.Latitude, this.mapData[0].Address.Longitude);
    map.panTo(position);
  }
}



// WEBPACK FOOTER //
// ./src/app/sharedcomponents/map-component/map.component.ts